import { Button, Box, Typography } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import FilterListIcon from "@mui/icons-material/FilterList";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import uploadicon from "../../assets/images/uploadicon.svg";
import { useUser } from "../../context/AuthContext";

const TopMenuUpload = ({
  heading,
  setAddData,
  setData,
  setDrawerFilterOpen,
  setBulkUploadModal,
  filterApplied,
}) => {
  const { user } = useUser();
  return (
    <Box
      sx={{
        pt: "2rem",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Box item xs={6} sx={{ paddingLeft: 0, display: "flex" }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            textDecoration: "underline",
            paddingLeft: "0",
          }}
        >
          {heading}
        </Typography>
      </Box>
      <Box
        item
        xs={6}
        sx={{
          textAlign: "right",
          my: heading && "1rem",
          mb: "1.5rem",
          width: "100%",
          display: "flex",
          gap: "0.7rem",
          justifyContent: "space-between",
        }}
      >
        <Box style={{ display: "flex", gap: "1rem" }}>
          {!user?.companyAdmin ? (
            <>
              <Button
                variant="contained"
                endIcon={<AddIcon />}
                sx={{
                  backgroundColor: "#1c486b",
                  fontSize: "16px",
                  textTransform: "none",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#1c486b",
                    opacity: 0.9,
                  },
                }}
                onClick={() => {
                  setAddData(true);
                  setData(null);
                }}
              >
                Add New
              </Button>
              {setBulkUploadModal &&
              <Button
                variant="contained"
                onClick={() => setBulkUploadModal(true)}
                endIcon={<img src={uploadicon} alt="upload" />}
                sx={{
                  backgroundColor: "#fff",
                  fontSize: "16px",
                  textTransform: "none",
                  color: "rgba(28, 72, 107, 1)",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  "&:hover": {
                    backgroundColor: "#fff",
                    opacity: 0.9,
                  },
                }}
              >
                Upload
              </Button>}
            </>
          ) : null}
        </Box>
        <Button
          variant="contained"
          onClick={() => setDrawerFilterOpen(true)}
          sx={{
            backgroundColor: "#ffffff",
            textTransform: "none",
            fontSize: "16px",
            fontFamily: "Inter",
            fontWeight: "500",
            color: "black",
            "&:hover": { backgroundColor: "#1c486b", color: "#FFFFFF" },
            "&:hover .dot-icon": { color: "#FFFFFF" },
          }}
        >
          Filter
          <FilterListIcon sx={{ marginLeft: "0.5rem" }} />
          {filterApplied && (
            <FiberManualRecordIcon
              className="dot-icon"
              sx={{
                fontSize: "16px",
                fontWeight: "500",
                color: "#488257",
                marginLeft: "5px",
                fontFamily: "Inter",
                textTransform: "none",
              }}
            />
          )}
        </Button>
      </Box>
    </Box>
  );
};

export default TopMenuUpload;
